<template>
  <div class="qaqc-summary-cards">
    <div class="qaqc-summary-card">
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['file-outline']" contain class="qaqc-summary-card-icon-img" />
      </div>
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-label-row">
          <span class="qaqc-summary-card-label">Total Tests</span>
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon"
                width="18"
                height="18"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.totalTests }}</div>
          </v-tooltip>
        </div>
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ totalTestsDisplay }}</span>
          <span v-if="badgePart(stats.totalTestsChange)" class="qaqc-summary-card-badge">{{ badgePart(stats.totalTestsChange) }}</span>
          <span class="qaqc-summary-card-meta" v-if="metaPart(stats.totalTestsChange)">{{ metaPart(stats.totalTestsChange) }}</span>
        </div>
          </div>
    </div>
    <div class="qaqc-summary-card">
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['chart-line-cce']" contain class="qaqc-summary-card-icon-img" />
      </div>
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-label-row">
          <span class="qaqc-summary-card-label">Constant Composition Expansion Tests</span>
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon"
                width="18"
                height="18"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.cceTests }}</div>
          </v-tooltip>
        </div>
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ stats.cceTests }}</span>
          <!-- <span v-if="badgePart(stats.cceTestsPercent)" class="qaqc-summary-card-badge">{{ badgePart(stats.cceTestsPercent) }}</span> -->
          <!-- <span class="qaqc-summary-card-meta" v-if="metaPart(stats.cceTestsPercent)">{{ metaPart(stats.cceTestsPercent) }}</span> -->
        </div>
      </div>
    </div>
    <div class="qaqc-summary-card">
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['chart-line-dl']" contain class="qaqc-summary-card-icon-img" />
      </div>
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-label-row">
          <span class="qaqc-summary-card-label">Differential Liberation Tests</span>
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon"
                width="18"
                height="18"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.dlTests }}</div>
          </v-tooltip>
        </div>
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ stats.dlTests }}</span>
          <!-- <span v-if="badgePart(stats.dlTestsPercent)" class="qaqc-summary-card-badge">{{ badgePart(stats.dlTestsPercent) }}</span> -->
          <!-- <span class="qaqc-summary-card-meta" v-if="metaPart(stats.dlTestsPercent)">{{ metaPart(stats.dlTestsPercent) }}</span> -->
        </div>
      </div>
    </div>
    <div class="qaqc-summary-card qaqc-summary-card-pass">
      <div class="qaqc-summary-card-icon-wrap">
        <v-img :src="icons['check-pass']" contain class="qaqc-summary-card-icon-img" />
      </div>
      <div class="qaqc-summary-card-content">
        <div class="qaqc-summary-card-label-row">
          <span class="qaqc-summary-card-label">Pass Rate</span>
          <v-tooltip location="top" content-class="qaqc-test-info-tooltip qaqc-overview-dashboard-tooltip">
            <template v-slot:activator="{ props }">
              <v-img
                v-bind="props"
                :src="infoIcon"
                class="qaqc-test-info-icon qaqc-overview-note-icon"
                width="18"
                height="18"
                alt=""
                aria-label="Metric description"
              />
            </template>
            <div class="qaqc-test-tooltip-content">{{ notes.passRate }}</div>
          </v-tooltip>
        </div>
        <div class="qaqc-summary-card-value-row">
          <span class="qaqc-summary-card-value">{{ stats.passRate }}</span>
          <!-- <span class="qaqc-summary-card-meta" v-if="metaPart(stats.passRate)">{{ metaPart(stats.passRate) }}</span> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { OVERVIEW_SUMMARY_NOTES } from "./overviewDashboardNotes.js";

export default {
  name: "SummaryCards",
  data() {
    return {
      notes: OVERVIEW_SUMMARY_NOTES,
      infoIcon: require("@/assets/Svg/infoIcon.svg"),
      icons: {
        "file-outline": require("@/assets/Svg/file-outline.svg"),
        "chart-line-cce": require("@/assets/Svg/chart-line-cce.svg"),
        "chart-line-dl": require("@/assets/Svg/chart-line-dl.svg"),
        "check-pass": require("@/assets/Svg/check-pass.svg"),
      },
    };
  },
  props: {
    stats: {
      type: Object,
      required: true,
      default: () => ({
        totalTests: 0,
        totalTestsChange: "",
        cceTests: 0,
        cceTestsPercent: "",
        dlTests: 0,
        dlTestsPercent: "",
        passRate: "0%",
      }),
    },
  },
  computed: {
    totalTestsDisplay() {
      const c = this.parseStatNum(this.stats.cceTests);
      const d = this.parseStatNum(this.stats.dlTests);
      if (c !== null && d !== null) return c + d;
      return this.stats.totalTests;
    },
  },
  methods: {
    parseStatNum(v) {
      if (v === undefined || v === null || v === "") return null;
      if (typeof v === "number" && !Number.isNaN(v)) return v;
      const s = String(v).trim();
      if (s === "-") return null;
      const n = Number(s.replace(/[^0-9.-]/g, ""));
      return Number.isNaN(n) ? null : n;
    },
    badgePart(s) {
      if (!s || typeof s !== "string") return "";
      const i = s.indexOf(" ");
      return i > 0 ? s.slice(0, i) : s;
    },
    metaPart(s) {
      if (!s || typeof s !== "string") return "";
      const i = s.indexOf(" ");
      return i > 0 ? s.slice(i + 1).trim() : "";
    },
  },
};
</script>

<style scoped>
.qaqc-summary-card-label-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  align-self: flex-start;
  max-width: 100%;
}
.qaqc-overview-note-icon {
  flex-shrink: 0;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.qaqc-summary-card-label-row :deep(.v-tooltip) {
  flex: 0 0 auto;
}
</style>
